<template>
  <div>
    <div class="m-subheader ">
      <div class="d-flex align-items-center">
        <div class="mr-auto">
          <ul class="m-subheader__breadcrumbs m-nav m-nav--inline">
		  			<li class="m-nav__item">
		  				<router-link :to="{name: 'home'}">
		  					<span class="m-nav__link-text">
                  <i class="m-nav__link-icon la la-home"></i>
                </span>
		  				</router-link>
		  			</li>
		  			<li class="m-nav__separator">
		  				>
		  			</li>
		  			<li class="m-nav__item">
		  				<a href="" class="m-nav__link">
		  					<span class="m-nav__link-text">
		  						{{'support' | translate | titleize}}
		  					</span>
		  				</a>
		  			</li>
		  		</ul>
        </div>
      </div>
    </div>
    <div class="m-content">
      <div class="m-portlet m-portlet--tab">
        <div class="m-portlet__head">
          <div class="m-portlet__head-caption">
            <div class="m-portlet__head-title">
              <span class="m-portlet__head-icon m--hide">
                <i class="la la-gear"></i>
              </span>
              <h3 class="m-portlet__head-text m--font-light">
                {{ 'manage_clients' | capitalize }}
              </h3>
            </div>
          </div>
        </div>

        <div class="m-portlet__body">
          <div class="m-widget17">
            <div class="m-widget17__visual m-widget17__visual--chart m-portlet-fit--top m-portlet-fit--sides m--bg-primary" style="background:#2c375b!important">
              <div class="m-widget17__chart">
              </div>
            </div>
            <div class="m-widget17__stats stats_support">
              <div class="m-widget17__items m-widget17__items-col1">
                <div class="m-widget17__item" data-toggle="modal" data-backdrop="static" data-keyboard="false" data-target="#support_modal" @click="createProperty">
                  <span class="m-widget17__icon">
                    <i class="flaticon-add m--font-brand"></i>
                  </span>
                  <span class="m-widget17__subtitle">
                    {{ 'create_property' | translate | titleize }}
                  </span>
                  <span class="m-widget17__desc">
                    {{ 'create_property_description' | translate | titleize }}
                  </span>
                </div>
              </div>
              <div class="m-widget17__items m-widget17__items-col2">
                <div class="m-widget17__item" data-toggle="modal" data-backdrop="static" data-keyboard="false" data-target="#support_modal" @click="changeStatusSupModal(true)">
                  <span class="m-widget17__icon">
                    <i class="flaticon-piggy-bank m--font-info"></i>
                  </span>
                  <span class="m-widget17__subtitle">
                    {{ 'modify_plans' | translate | titleize }}
                  </span>
                  <span class="m-widget17__desc">
                    {{ 'modify_plans_description' | translate | titleize }}
                  </span>
                </div>
              </div>
              <div class="m-widget17__items m-widget17__items-col3">
                <div class="m-widget17__item" @click="goToSyncComplete">
                  <span class="m-widget17__icon">
                    <i class="flaticon-list-1 m--font-success"></i>
                  </span>
                  <span class="m-widget17__subtitle">
                    {{ 'sync_complete' | translate | titleize }}
                  </span>
                  <span class="m-widget17__desc">
                    {{ 'sync_complete_description' | translate | titleize }}
                  </span>
                </div>
              </div>
            </div>
            <div class="m-widget17__stats stats_support">
              <div class="m-widget17__items m-widget17__items-col1">
                <div class="m-widget17__item" @click="goToSyncControl">
                  <span class="m-widget17__icon">
                    <i class="flaticon-interface-4 m--font-brand"></i>
                  </span>
                  <span class="m-widget17__subtitle">
                    {{ 'sync_control' | translate | titleize }}
                  </span>
                  <span class="m-widget17__desc">
                    {{ 'sync_control_description' | translate | titleize }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <s-modal id="support_modal" :title="create_property ? 'create_property' : 'assign_plan' | translate | titleize">
        <s-new-property v-show="create_property" slot="body"></s-new-property>
        <s-assing-plan  v-show="!create_property" slot="body"></s-assing-plan>
      </s-modal>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import SModal from '@/components/layout/modal/Modal.vue'
import SNewProperty from '@/components/property/NewProperty.vue'
import SAssingPlan from '@/components/property/Plan.vue'
export default {
  components: { SModal, SNewProperty, SAssingPlan },
  data () {
    return {
      create_property: false
    }
  },
  computed: {
    ...mapGetters({modal: 'getStatusSupModal', permissions: 'getUserPermissions'})
  },
  methods: {
    ...mapActions(['changeStatusSupModal']),
    validPermission (action, entity) {
      if (this.permissions.find(p => { return (p.action === action && p.entity === entity) })) {
        return true
      } else {
        return false
      }
    },
    createProperty () {
      this.create_property = true
      this.changeStatusSupModal(true)
    },
    goToSyncComplete () {
      this.$router.push({name: 'sync_complete'})
    },
    goToSyncControl () {
      this.$router.push({name: 'sync_control'})
    }
  },
  watch: {
    modal (newVal, oldVal) {
      if (oldVal === true && newVal === false) {
        this.create_property = false
      }
    }
  }
}
</script>

<style scoped>
.stats_support {
  margin-bottom: 65px !important
}
.m-widget17__items {
  width: 33% !important
}

.m-widget17__item {
  cursor: pointer;
}

.m-widget17__item:hover {
  background-color: #efeded !important;
  transition: 0.3s;
}
</style>



// WEBPACK FOOTER //
// Support.vue